import {
  CREATE_PURCHASE_START,
  CREATE_PURCHASE_SUCCESS,
  CREATE_PURCHASE_FAILED,
  FETCH_CUSTOMERS_START,
  FETCH_CUSTOMERS_SUCCESS,
  APPEND_CUSTOMER_PAGE,
  FETCH_CUSTOMERS_FILTERED_START,
  FETCH_CUSTOMERS_FAILED,
  UPDATE_CUSTOMER_START,
  UPDATE_CUSTOMER_SUCCESS,
  UPDATE_CUSTOMER_FAILED,
  DELETE_RECORD_SUCCESS,
  UPDATE_CUSTOMER_PAGE_COUNT,
  FETCH_CUSTOMER_OPTIONS_START,
  FETCH_CUSTOMER_OPTIONS_SUCCESS,
  UPDATE_CUSTOMER_BUNDLE_USAGE_START,
  UPDATE_CUSTOMER_BUNDLE_USAGE_SUCCESS,
  UPDATE_CUSTOMER_BUNDLE_USAGE_FAILED
} from "../actions";

const customersReducer = (state = { hasMore: true, page: 0 }, action) => {
  switch (action.type) {
    case CREATE_PURCHASE_START:
    case UPDATE_CUSTOMER_START:
      return { ...state, inProgress: true };
    case FETCH_CUSTOMERS_START:
      return { ...state, inProgress: true, hasMore: false };
    case UPDATE_CUSTOMER_PAGE_COUNT:
      return { ...state, page: action.payload };
    case FETCH_CUSTOMERS_SUCCESS:
      return {
        ...state,
        errors: null,
        list: action.payload.customers,
        inProgress: false,
        customerMetadataItems: action.payload.customerMetadataItems,
        customerGroupings: action.payload.customerGroupings,
        purchases: action.payload.purchases,
        products: action.payload.products
      };
    case FETCH_CUSTOMER_OPTIONS_START:
      return {
        ...state,
        referencesLoading: true
      };
    case FETCH_CUSTOMER_OPTIONS_SUCCESS:
      return {
        ...state,
        references: action.payload.customers,
        referencesLoading: false
      };
    case "@@router/LOCATION_CHANGE":
      return {
        hasMore: true,
        page: 0
      };
    case FETCH_CUSTOMERS_FILTERED_START:
      return {
        hasMore: false,
        resetPage: true
      };
    case APPEND_CUSTOMER_PAGE:
      return {
        ...state,
        list: { ...state.list, ...action.payload.customers },
        hasMore: action.hasMore,
        customerMetadataItems: { ...state.customerMetadataItems, ...action.payload.customerMetadataItems },
        customerGroupings: { ...state.customerGroupings, ...action.payload.customerGroupings },
        purchases: { ...state.purchases, ...action.payload.purchases },
        products: { ...state.products, ...action.payload.products },
        resetPage: false
      };
    case FETCH_CUSTOMERS_FAILED:
      return { ...state, errors: action.errors, list: null, inProgress: false };
    case UPDATE_CUSTOMER_SUCCESS:
      return { ...state, inProgress: false, errors: null };
    case UPDATE_CUSTOMER_FAILED:
      return { ...state, inProgress: false, errors: action.errors };
    case UPDATE_CUSTOMER_BUNDLE_USAGE_START:
      return {
        ...state,
        inProgress: true
      };
    case UPDATE_CUSTOMER_BUNDLE_USAGE_SUCCESS:
      return {
        ...state,
        inProgress: false
      };
    case UPDATE_CUSTOMER_BUNDLE_USAGE_FAILED:
      return { ...state, inProgress: false, errors: action.errors };
    case CREATE_PURCHASE_SUCCESS:
    case CREATE_PURCHASE_FAILED:
      return { ...state, inProgress: false };
    case DELETE_RECORD_SUCCESS:
      return state;
    default:
      return state;
  }
};

export default customersReducer;
